import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import {
  PermissionStatus,
  checkForNewPermissonStatus,
  customPermissionApiKey,
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";

export interface ITimeSlot {
  id: number;
  end_time: Date;
  start_time: Date;
  promotion_id: number;
  endDate: Date | string | null | undefined | never;
  startDate: Date | string | null | undefined | never;
}

interface IOption {
  id: number;
  name: string;
  area_name?: string;
  store_name?: string;
  branch_name?: string;
  region_name?: string;
  product_name?: string;
  product_type?: string;
}

export interface IGoldenPoint {
  id: number;
  item_type: string;
  catalogue_id: number | null;
  product_name?: string;
  applicable_products_count?: number;
  catalogue?: {
    id: number;
    product_name: string;
  } | null;
}

export interface IProductItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    product_name: string;
    product_second_name: string;
    product_type: { id: number; value: string };
    applicable_products_count: number;
  };
}

export interface IData {
  // id: string;
  attributes: {
    name: string;
    name_arabic: string;
    golden_point_text_en: string;
    golden_point_text_ar: string;
    receipt_text: string;
    base_points: number;
    bonus_points: number;
    total_points: number;
    vat_points: number;
    final_price: number;
    price: number;
    vat: string;
    free_wash_quentity: number;
    is_redeem: boolean;
    free_wash_description: string;
    start_date_base: Date | null;
    end_date_base: Date | null;
    start_date_bonus: Date | null;
    end_date_bonus: Date | null;
    promo_expires_base: boolean;
    expiry_days_base: number | null;
    promo_expires_bonus: boolean;
    expiry_days_bonus: number | null;
    purchase_start_date: Date | null;
    purchase_end_date: Date | null;
    start_date_free_wash: Date | null;
    end_date_free_wash: Date | null;
    used: string;
    status: boolean;
    no_of_orders: number | string | null;
    minimum_order_amount: number | string;
    minimum_items: number | string;
    start_date: string | Date | null | never;
    end_date: string | Date | null | never;
    mobile_description: string;
    sections: Array<string | never>;
    categories: Array<string | never>;
    services: Array<string | never>;
    product_ids: Array<string | never>;
    platforms: Array<string | never>;
    regions: Array<string | never>;
    areas: Array<string | never>;
    free_wash_product: Array<string | never>;
    free_wash_item_type: Array<string | never>;
    applicable_products_count:number,
    store_managements: Array<string | never>;
    store_management_ids: Array<string | never>;
    exclude_days: Array<string | never>;
    excluded_dates: Array<{
      id: number;
      excluded_date: string;
      reason?: string;
      display_date?: string;
    }>;
    excluded_times: Array<{
      id: number;
      start_time: string;
      end_time: string;
      display_range?: string;
    }>;
    available_times: Array<{
      id: number;
      start_time: string;
      end_time: string;
      display_range?: string;
    }>;
    is_currently_active?: boolean;
    is_expired?: boolean;
    error: "";
    isLoading: false;
    isSaveLoader: false;
    noData: false;
    saveStatus: "";
    regionList: [];
    areaList: [];
    sectionList: [];
    serviceList: [];
    productList: [];
    platformList: [];
    storeList: [];
    selectedRegions: [];
    selectedAreas: [];
    selectedSections: [];
    selectedProducts: [];
    selectedPlatforms: [];
    selectedStores: [];
  };
}

interface Props {
  navigation: {
    navigate: Function;
    getParam: Function;
  };
}

interface State {
  noData: boolean;
  isLoading: boolean;
  isViewLoading: boolean;
  data: IData | never;
  permissionStatus: PermissionStatus;
  isLoadingPermission: boolean;
}

interface SS {}
// Customizable Area Start
const configJSON = require("./config");
const ApiUrls = configJSON.ApiUrls;

class GoldenPointViewController extends BlockComponent<Props, State, SS> {
  constructor(props: Props) {
    super(props);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.LayoutDataMessage),
    ];
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  goldenPointShowMessageId: string = "";

  state: State = {
    // Customizable Area Start
    noData: false,
    isLoading: true,
    isViewLoading: false,
    data: {
      attributes: {
        base_points: 0,
        bonus_points: 0,
        total_points: 0,
        vat_points: 0,
        final_price: 0.0,
        price: 0.0,
        vat: "",
        start_date_base: null,
        end_date_base: null,
        start_date_bonus: null,
        end_date_bonus: null,
        promo_expires_base: false,
        expiry_days_base: null,
        promo_expires_bonus: false,
        expiry_days_bonus: null,
        start_date_free_wash: null,
        end_date_free_wash: null,
        purchase_start_date: null,
        purchase_end_date: null,
        name: "",
        name_arabic: "",
        golden_point_text_en: "",
        golden_point_text_ar: "",
        receipt_text: "",
        used: "all_orders",
        no_of_orders: null,
        minimum_order_amount: "",
        minimum_items: 1,
        start_date: null,
        end_date: null,
        status:false,
        free_wash_product: [],
        free_wash_item_type:[],
        applicable_products_count:0,
        services: [],
        excluded_dates: [],
        excluded_times: [],
        mobile_description: "",
        regionList: [],
        areaList: [],
        sectionList: [],
        serviceList: [],
        productList: [],
        platformList: [],
        storeList: [],
        is_currently_active: false,
        selectedRegions: [],
        selectedAreas: [],
        selectedSections: [],
        selectedProducts: [],
        selectedPlatforms: [],
        selectedStores: [],
        // excluded_days: Array<string | never>;
        free_wash_description: "",
        free_wash_quentity: 0,
        is_redeem: false,
        error: "",
        isLoading: false,
        isSaveLoader: false,
        noData: false,
        saveStatus: "",
        sections: [],
        categories: [],
        product_ids: [],
        platforms: [],
        regions: [],
        areas: [],
        available_times: [],
        // selectedSections: [],
        // selectedProducts: [],
        exclude_days: [],
        store_management_ids: [],
        store_managements: [],
      },
    },
    permissionStatus: {
      mainPermission: false,
      createPermission: false,
      viewPermission: false,
      editPermission: false,
      deactivatePermission: false,
    },
    isLoadingPermission: true,
    // Customizable Area End
  };

  receive(_from: string, message: Message): void {
    // Customizable Area Start
    this.receiveDataFromLayout(message);
    let requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    let successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    if (successResponse?.data) {
      if (requestId === this.goldenPointShowMessageId) {
        let data = successResponse.data;

        data.attributes.categories =
          data.attributes.sections?.data?.map(
            (item: any) => item.attributes.section_name
          ) || [];

        data.attributes.services =
          data.attributes.services?.data?.map(
            (item: any) => item.attributes?.name
          ) || [];
        const productNames: string[] =
          data.attributes.product_ids?.data?.map(
            (item: IProductItem) => item.attributes.name
          ) || [];

        const freeWashProductNames: string[] =
          data.attributes.free_wash_product_ids?.data?.map(
            (item: IProductItem) => item.attributes.name
          ) || [];

          const freeWashProducts =
            data.attributes.free_wash_product_ids?.data?.map(
              (item: IProductItem, index: number) => ({
                product_name: item.attributes.name,
                item_type:
                  data.attributes.free_wash_item_type?.[index]?.item_type || "",
                applicable_products_count:
                  item.attributes.applicable_products_count || 0,
              })
            ) || [];

          data.attributes.free_wash_product = freeWashProducts;

        data.attributes.product_ids = productNames;
        // data.attributes.free_wash_product = freeWashProductNames;

        data.attributes.platforms =
          data.attributes.platforms?.map((item: IOption) => item.name) || [];

        data.attributes.store_managements =
          data.attributes.store_managements?.data?.map(
            (item: any) => item.attributes.store_name
          ) || [];

        data.attributes.areas =
          data.attributes.areas?.data?.map(
            (item: any) => item.attributes?.area_name
          ) || [];

          data.attributes.regions =
          data.attributes.regions?.data?.map(
            (item: any) => item.attributes?.name
          ) || [];

        data.attributes.excluded_days =
          data.attributes.excluded_days?.map(
            (item: { day_of_week: string; display_name?: string }) =>
              item.display_name || item.day_of_week
          ) || [];

        this.setState({
          isViewLoading: false,
          isLoading: false,
          noData: false,
          data,
        });
      }
    } else if (successResponse?.error) {
      if (requestId === this.goldenPointShowMessageId) {
        this.setState({ isViewLoading: false, isLoading: false, noData: true });
      }
    }

    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    this.getPromotionItemApi();
    // Customizable Area End
  }

  // Customizable Area Start

  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleUserChange(recievedData.userContext);
      }
    }
  };

  getPromotionItemApi() {
    this.setState({ isViewLoading: true });
    const id = this.props.navigation.getParam("id");
    const requestMessage = MakeApiMessage({
      url: ApiUrls.goldenPointShow + id,
      method: "GET",
    });
    console.log("Request Message", requestMessage);
    this.goldenPointShowMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  redirectTo(page: string, props = {}) {
    this.props.navigation.navigate(page, props);
  }

  handleUserChange = (userContext: IUserContext) => {
    const apiKey = customPermissionApiKey.promocodePermissions;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForNewPermissonStatus(
      apiKey,
      userData as Array<PermissionGroupArray>
    );
    this.setState({
      permissionStatus: value,
      isLoadingPermission: false,
    });
  };

  // Customizable Area End
}

export default GoldenPointViewController;
